const defaultFilterName = 'Все';

function getDirectionData(directions, matchParams) {
    return Object.values(directions).find(({ pathParams }) => pathParams === matchParams);
}

function getStartScreenData(directions, matchParams) {
    const {
        animation,
        headline,
        headlineSmall,
        description,
        isDescComponent,
    } = getDirectionData(directions, matchParams);
    return {
        animation,
        headline,
        headlineSmall,
        description,
        isDescComponent,
    };
}

function getFilters(directions, matchParams) {
    const { services } = getDirectionData(directions, matchParams);
    return [
        {
            name: defaultFilterName,
            isActive: true,
            filterID: services.map(({ uuid }) => uuid),
        },
        ...services.map(
            ({ name, uuid }) => (
                {
                    name,
                    isActive: false,
                    filterID: [uuid],
                }
            ),
        ),
    ];
}

function getServices(directions, matchParams) {
    const { services } = getDirectionData(directions, matchParams);
    return services;
}

function getCheckboxes(filters) {
    return filters.length > 1
        ? filters.reduce(
            (agg, { name, filterID }) => (
                name !== defaultFilterName ? [...agg, { name, isChecked: false, filterID }] : agg
            ), [],
        ) : [];
}

function getFiltersIDArray(filters, filterName = defaultFilterName) {
    return filters.find(({ name }) => name === filterName).filterID;
}

function updateFilters(filters, filterName = defaultFilterName) {
    return filters.map((filter) => ({ ...filter, isActive: filter.name === filterName }));
}

function getLimitByScreen() {
    return window.innerWidth < 768 ? 3 : 6;
}

function getMoreDownloadNum({ count, cases, limit }) {
    const delta = count - cases.length;
    return delta < limit ? delta : limit;
}

function getFilterName(filters) {
    return filters.find(({ isActive }) => isActive).name;
}

function updateCasesState(casesState, incomingData, isChangeFilter = false) {
    const { data, count } = incomingData;
    return {
        ...casesState,
        cases: isChangeFilter ? data : [...casesState.cases, ...data],
        count,
    };
}

const defaultCasesState = {
    cases: [],
    limit: getLimitByScreen(),
    count: 0,
};

function getDirectionState(directions, direction) {
    return {
        isChangeFilter: false,
        isLoadMoreCases: false,
        services: getServices(directions, direction),
        filters: getFilters(directions, direction),
        casesState: defaultCasesState,
    };
}

export default {
    getStartScreenData,
    defaultCasesState,
    getDirectionState,
    updateCasesState,
    getFiltersIDArray,
    updateFilters,
    getMoreDownloadNum,
    getFilterName,
    getCheckboxes,
};
